/** @jsxImportSource @emotion/react */
import { accordionHeader } from './HazardControls.styles'
import { HazardDetail } from '@app/components/Molecules/MapView/RiskMapView/AddLayersDialog'
import { CombinedHazardDetail, getScenarioByHazardDetail } from '../HazardControls'
import { useSelector } from 'react-redux'
import { RootState } from '@app/redux/store'
import { usePreferences } from '@app/hooks/usePreferences'

export interface HazardControlFormHeaderProps {
  hazardDetails: HazardDetail | CombinedHazardDetail
}

export const HazardControlFormHeader_Legacy = ({ hazardDetails }: HazardControlFormHeaderProps) => {
  const { layers } = useSelector((state: RootState) => state.riskMap)
  const mapLayer = getScenarioByHazardDetail(layers, hazardDetails as CombinedHazardDetail)
  const { use_hazard_name } = usePreferences()

  return (
    <span css={accordionHeader}>
      {use_hazard_name.flag
        ? (mapLayer?.hazard_name ?? mapLayer?.display_name ?? hazardDetails.title)
        : mapLayer?.display_name || hazardDetails.title}
      <span>{mapLayer?.scenario_name}</span>
    </span>
  )
}
